import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Waves } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}!`);
      nav(u.role === "parent" ? "/parent" : "/student");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 stripe">
      <div className="hidden lg:flex flex-col justify-center px-16">
        <div className="flex items-center gap-2 mb-8">
          <span className="grid place-items-center w-10 h-10 rounded-2xl bg-teal-700 text-white"><Waves size={20} strokeWidth={2.5} /></span>
          <span className="font-display text-2xl font-bold text-slate-900">Oceanic Learn</span>
        </div>
        <h2 className="font-display text-4xl font-bold text-slate-900 leading-tight">Welcome back.<br/><span className="text-teal-700">Let's pick up where you left off.</span></h2>
        <p className="mt-4 text-slate-600 max-w-md">Your progress, missions, and Beach Lab notes are all waiting.</p>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl border border-slate-200 shadow-sm p-8">
          <h1 className="font-display text-2xl font-bold text-slate-900">Log in</h1>
          <p className="mt-1 text-sm text-slate-500">Parent or student account.</p>
          <label className="block mt-6 text-sm font-medium text-slate-700">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
            className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-100 outline-none" />
          <label className="block mt-4 text-sm font-medium text-slate-700">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
            className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-teal-500 focus:ring-2 focus:ring-teal-100 outline-none" />
          <button data-testid="login-submit" disabled={loading} type="submit"
            className="mt-6 w-full py-3 rounded-full bg-teal-700 hover:bg-teal-800 text-white font-semibold transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Log in"}
          </button>
          <p className="mt-4 text-sm text-slate-500 text-center">
            New here? <Link to="/register" data-testid="login-to-register" className="text-teal-700 font-semibold">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
